import {
  BUNDLE_SEARCH_FAILURE,
  BUNDLE_SEARCH_SUCCESS,
  BUNDLE_SEARCH_REQUEST,
  DOMAIN_SEARCH_RESET_CACHE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";
import unicodeTld from "lib/unicodeTld";

const bundleSearchRequest = createAction(BUNDLE_SEARCH_REQUEST);
const bundleSearchSuccess = createAction(BUNDLE_SEARCH_SUCCESS);
const bundleSearchFailure = createErrorAction(BUNDLE_SEARCH_FAILURE);
const domainSearchResetCache = createAction(DOMAIN_SEARCH_RESET_CACHE);

export const loadBundlesByType = (type, keyword) => {
  return async (dispatch, getState, { api }) => {
    const { cart, domains } = getState();
    const keywordInSession = window.localStorage.getItem("keyword");
    const keywordInDOM = document.getElementById("keyword");
    const category = type === "popular" ? "filteredDomains" : "all";
    keyword = keyword === null ? false : keyword;

    // No keyword was passed as arg - Check for a keyword in localStorage
    if (keywordInSession) {
      keyword = { value: keywordInSession };
    }

    // No keyword in localStorage - Check for a keyword in the DOM
    if (!keyword && keywordInDOM) {
      keyword = { value: keywordInDOM.value };
    }

    // If we still don't have a keyword, find the first domain in the cart and use that
    // as keyword
    if (!keyword && cart.cartItems.length > 0) {
      const firstDomainInCart = cart.cartItems[0];

      if (
        firstDomainInCart.fullDomain &&
        firstDomainInCart.fullDomain !== "nodomain.notld"
      ) {
        const fullDomain = firstDomainInCart.fullDomain;
        keyword = { value: fullDomain.substring(0, fullDomain.indexOf(".")) };
      }
    }

    if (!keyword) {
      dispatch(bundleSearchFailure(new Error("No keyword found.")));
      return;
    }

    // Check if we can return a cached result
    // A cached result is a search on the same keyword as the redux state has
    // while also having the type saved.
    // Additionally we check for when then cache was saved
    if (
      keyword.value === domains.keyword &&
      domains[category].hasOwnProperty(type) === true &&
      Date.now() - 60000 < domains.domainsLoadedTimestamp
    ) {
      return;
    }

    // Save keyword in localStorage
    window.localStorage.setItem("keyword", keyword.value);

    // If we have a cache and the keyword changed
    // invalidate the cache

    if (
      Object.keys(domains[category]).length > 0 &&
      keyword.value !== domains.keyword
    ) {
      dispatch(domainSearchResetCache());
    }
    // Load request
    dispatch(bundleSearchRequest());

    // API call
    return api
      .getBundleByType(unicodeTld(keyword.value), type.toUpperCase())
      .then(
        (data) => {
          dispatch(
            bundleSearchSuccess({
              bundles: data.bundles,
              currency: data.currency,
              defaultIncludeVat: data.defaultIncludeVat,
              decimalSeparator: data.decimalSeparator,
              type: type.toLowerCase(),
              keyword: keyword.value,
              monthlyPrices: data.monthlyPrices,
            }),
          );

          return true;
        },
        (err) => {
          dispatch(bundleSearchFailure(err));
        },
      );
  };
};
